
<div class="d-flex flex-row justify-content-between align-items-center">
  <span class="font-activity-list-title">{{title | translate}}</span>
  <mat-icon class="icon-size-30" [ngClass]="{'font-white': UIUtilityService.isMobileWhiteTitle()}" svgIcon="farTimesCircle" (click)="navigateToDashboard()"></mat-icon>
</div>

<mat-divider class="my-3" [ngClass]="UIUtilityService.isMobileWhiteTitle() ? 'title-divider-white' : 'title-divider-dark'"></mat-divider>

<ng-container *ngFor="let activity of activityList">
  <div class="container p-3 mb-3 field-box" [ngClass]="UIUtilityService.getMobileActivityBackground()" (click)="navigate(activity)" matRipple>
    <div class="d-flex justify-content-between">
      <div class="font-activity-list-item d-flex flex-row align-items-center">
        @if(activity.type == SidebarActivityType.DEFAULT) { <span>{{activity.label | translate}}</span> }
        @else if(activity.type == SidebarActivityType.VIZ) {
          <span class="viz-font-activity-list-item me-1">{{ ('VIZ.VIZ' | translate)}}</span><span>{{ (activity.label | translate) }}</span>
        }
      </div>
      <div class="font-white">
        <mat-icon svgIcon="falChevronRight"></mat-icon>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="this.category">
  <app-me-marketing-banner [category]="this.category" [views]="BannerView.MOBILE"></app-me-marketing-banner>
</ng-container>
